import styled from "styled-components"

export const Wrapper = styled.div`
	> iframe {
		height: 300px;
	}
`
